import { Deserializable } from '../protocols/deserializable';
import { FiduciaryEntityTypeEnum } from '../../views/fiduciaries/enums/fiduciary-entity-type.enum';
import { FiduciaryEntityType } from '../../views/fiduciaries/models/fiduciary-entity-type';
import { FiduciaryPowerOfAttorneyAppointmentType } from '../../views/fiduciaries/models/fiduciary-power-of-attorney-appointment-type';
import { FiduciaryPowerOfAttorneyType } from '../../views/fiduciaries/models/fiduciary-power-of-attorney-type';
import { FiduciaryType } from '../../views/fiduciaries/models/fiduciary-type';
import { FiduciaryTypeEnum } from '../../views/fiduciaries/enums/fiduciary-type.enum';
import { FiduciarySubmissionIndividualEntity } from '../../views/fiduciaries/models/fiduciary-submission-individual-entity';
import { FiduciarySubmissionOrganizationEntity } from '../../views/fiduciaries/models/fiduciary-submission-organization-entity';

export class UpdateLegalFiduciarySubmissionData implements Deserializable {
  public appointmentDate: string | null = null;
  public effectiveDate: string | null = null;
  public endDate: string | null = null;
  public entityTypeId: FiduciaryEntityTypeEnum | null = null;
  public entityType: FiduciaryEntityType | null = null;
  public individualEntities: FiduciarySubmissionIndividualEntity[] = [];
  public note: string | null = null;
  public numberOfAttorneysToMakeAChange: number | null = null;
  public organizationEntity: FiduciarySubmissionOrganizationEntity | null = null;
  public powerOfAttorneyAppointmentTypeId: number | null = null;
  public powerOfAttorneyAppointmentType: FiduciaryPowerOfAttorneyAppointmentType | null = null;
  public powerOfAttorneyTypeId: number | null = null;
  public powerOfAttorneyType: FiduciaryPowerOfAttorneyType | null = null;
  public receivedDate: string | null = null;
  public typeId: FiduciaryTypeEnum | null = null;
  public type: FiduciaryType | null = null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.entityType) {
      this.entityType = Deserialize.instanceOf(FiduciaryEntityType, this.entityType);
    }

    if (this.individualEntities.length) {
      this.individualEntities = Deserialize.arrayOf(FiduciarySubmissionIndividualEntity, this.individualEntities);
    }

    if (!!this.organizationEntity) {
      this.organizationEntity = Deserialize.instanceOf(FiduciarySubmissionOrganizationEntity, this.organizationEntity);
    }

    if (!!this.powerOfAttorneyAppointmentType) {
      this.powerOfAttorneyAppointmentType = Deserialize.instanceOf(
        FiduciaryPowerOfAttorneyAppointmentType,
        this.powerOfAttorneyAppointmentType
      );
    }

    if (!!this.powerOfAttorneyType) {
      this.powerOfAttorneyType = Deserialize.instanceOf(FiduciaryPowerOfAttorneyType, this.powerOfAttorneyType);
    }

    if (!!this.type) {
      this.type = Deserialize.instanceOf(FiduciaryType, this.type);
    }
  }
}
